/*
 * Frete grátis por região (CEP) — Plenitude
 * Finaliza o esqueleto deixado no tema: lê #plenitude-cep-region-config,
 * engancha no CEP existente ([data-shipping-cep]), deriva a região via ViaCEP
 * e ajusta o threshold da barra de progresso (<progress-bar>).
 *
 * - Tudo atrás do toggle enable_cep_region (data-enabled). OFF => não faz nada.
 * - ANTES do CEP: barra escondida + linha-convite (não usa o fallback).
 * - DEPOIS do CEP: valor da região; se a UF não resolver, cai no default (fallback).
 * - Persiste CEP/UF em cookie (dias vindos do config). Sem valor hardcoded aqui.
 */
(function () {
  'use strict';

  var CFG = document.getElementById('plenitude-cep-region-config');
  if (!CFG || CFG.dataset.enabled !== 'true') return; // toggle OFF => comportamento nativo do tema

  // ---------- helpers ----------
  function num(x) { var v = parseFloat(String(x == null ? '' : x).replace(',', '.')); return isFinite(v) ? v : 0; }
  function money(v) { return 'R$ ' + v.toFixed(2).replace('.', ','); }

  var COOKIE = 'pl_cep_region';
  var COOKIE_DAYS = parseInt(CFG.dataset.cepCookieDays || '30', 10) || 30;
  var DEFAULT = num(CFG.dataset.defaultThreshold); // reais (fallback, pós-CEP)
  var MSG_PROGRESS = CFG.dataset.msgFreeShippingProgress || 'Faltam {{ amount }} para o FRETE GRÁTIS';
  var MSG_DONE = CFG.dataset.msgFreeShippingDone || 'Você tem FRETE GRÁTIS!';
  var MSG_PROMPT = CFG.dataset.msgCepPrompt || 'Informe seu CEP em "Calcular Frete" e veja o frete grátis da sua região';

  var THRESHOLDS = {
    sp: num(CFG.dataset.thresholdSp),
    sul_sudeste: num(CFG.dataset.thresholdSulSudeste),
    centro_oeste: num(CFG.dataset.thresholdCentroOeste),
    nordeste: num(CFG.dataset.thresholdNordeste),
    norte: num(CFG.dataset.thresholdNorte)
  };

  // Lista fechada UF -> região (valida a UF vinda do ViaCEP; nada de input cru).
  var UF_REGION = {
    SP: 'sp',
    RJ: 'sul_sudeste', MG: 'sul_sudeste', ES: 'sul_sudeste', PR: 'sul_sudeste', SC: 'sul_sudeste', RS: 'sul_sudeste',
    GO: 'centro_oeste', MT: 'centro_oeste', MS: 'centro_oeste', DF: 'centro_oeste',
    MA: 'nordeste', PI: 'nordeste', CE: 'nordeste', RN: 'nordeste', PB: 'nordeste', PE: 'nordeste', AL: 'nordeste', SE: 'nordeste', BA: 'nordeste',
    AC: 'norte', AM: 'norte', RR: 'norte', RO: 'norte', PA: 'norte', AP: 'norte', TO: 'norte'
  };

  var state = load(); // {cep, uf} | null
  var obs = null;
  var scheduled = false;

  // ---------- cookie ----------
  function setCookie(v) {
    var d = new Date(); d.setTime(d.getTime() + COOKIE_DAYS * 864e5);
    document.cookie = COOKIE + '=' + encodeURIComponent(v) + '; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
  }
  function getCookie() {
    var m = document.cookie.match(new RegExp('(?:^|; )' + COOKIE + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function load() { try { return JSON.parse(getCookie() || 'null'); } catch (e) { return null; } }
  function save(cep, uf, persist) {
    state = { cep: cep, uf: uf };
    if (persist) { try { setCookie(JSON.stringify(state)); } catch (e) {} }
  }

  // ---------- regra de valor ----------
  function thresholdForUF(uf) {
    var region = UF_REGION[uf];
    var t = region ? THRESHOLDS[region] : 0;
    return (t && t > 0) ? t : DEFAULT; // UF fora do mapa -> default
  }
  // null => antes do CEP (mostra convite). número => aplica na barra.
  function currentThreshold() {
    if (!state) return null;                 // nunca digitou CEP
    if (state.uf) { var t = thresholdForUF(state.uf); return t > 0 ? t : null; }
    return DEFAULT > 0 ? DEFAULT : null;     // CEP digitado, sem região -> fallback
  }

  // ---------- render ----------
  function setText(el, msg, amountStr) {
    var parts = String(msg).split('{{ amount }}');
    el.textContent = '';
    el.appendChild(document.createTextNode(parts[0] || ''));
    if (parts.length > 1) {
      var strong = document.createElement('strong');
      strong.textContent = amountStr;
      el.appendChild(strong);
      el.appendChild(document.createTextNode(parts.slice(1).join('{{ amount }}')));
    }
  }
  function renderBar(bar, threshold) {
    var value = num(bar.getAttribute('value')) / 100; // cart.total_price (centavos) mantido pelo tema
    var done = value >= threshold;
    bar.setAttribute('max', Math.round(threshold * 100));
    bar.setAttribute('data-complete', done ? 'true' : 'false');
    bar.removeAttribute('hidden');
    var fill = bar.querySelector('.progress-bar__bar-fill');
    if (fill) fill.style.width = (done ? 100 : Math.min(100, value / threshold * 100)) + '%';
    var text = bar.querySelector('.progress-bar__text');
    if (text) {
      if (done) text.textContent = MSG_DONE;
      else setText(text, MSG_PROGRESS, money(Math.max(0, threshold - value)));
    }
  }
  function wrapOf(bar) { return bar.closest('.cart-heading__progress') || bar.parentElement; }
  function showCue(bar) {
    var wrap = wrapOf(bar); if (!wrap) return;
    var cue = wrap.querySelector('.pl-cep-cue');
    if (!cue) {
      cue = document.createElement('div');
      cue.className = 'pl-cep-cue';
      cue.setAttribute('role', 'status');
      wrap.appendChild(cue);
    }
    cue.textContent = '📍 ' + MSG_PROMPT;
    cue.hidden = false;
  }
  function hideCue(bar) {
    var wrap = wrapOf(bar);
    var cue = wrap && wrap.querySelector('.pl-cep-cue');
    if (cue) cue.hidden = true;
  }

  function applyAll() {
    if (obs) obs.disconnect(); // evita auto-disparo pelas nossas próprias mutações
    try {
      var threshold = currentThreshold();
      var bars = document.querySelectorAll('progress-bar.progress-bar');
      for (var i = 0; i < bars.length; i++) {
        var bar = bars[i];
        if (threshold) { hideCue(bar); renderBar(bar, threshold); }
        else { bar.setAttribute('hidden', ''); showCue(bar); }
      }
    } finally {
      if (obs) obs.observe(document.body, { childList: true, subtree: true });
    }
  }
  function scheduleApply() {
    if (scheduled) return; scheduled = true;
    requestAnimationFrame(function () { scheduled = false; applyAll(); });
  }

  // ---------- CEP ----------
  function lookup(cep) {
    return fetch('https://viacep.com.br/ws/' + cep + '/json/')
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d && !d.erro && d.uf) ? String(d.uf).toUpperCase() : null; })
      .catch(function () { return null; });
  }
  function onCep(raw) {
    var cep = String(raw || '').replace(/\D/g, '');
    if (cep.length !== 8) return;
    if (state && state.cep === cep) { scheduleApply(); return; } // já resolvido
    lookup(cep).then(function (uf) {
      if (uf && UF_REGION[uf]) save(cep, uf, true);   // resolvido -> persiste
      else save(cep, null, false);                    // falhou/UF fora -> só sessão (default)
      scheduleApply();
    });
  }
  function hookInputs() {
    var inputs = document.querySelectorAll('[data-shipping-cep], [data-plenitude-mini-cart-cep], input[name="cep"]');
    for (var i = 0; i < inputs.length; i++) {
      var inp = inputs[i];
      if (inp.__plHooked) continue; inp.__plHooked = true;
      var fire = (function (el) { return function () { onCep(el.value); }; })(inp);
      inp.addEventListener('change', fire);
      inp.addEventListener('blur', fire);
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') setTimeout(fire, 0); });
    }
  }

  // ---------- css do convite ----------
  function injectStyle() {
    if (document.getElementById('pl-cep-cue-style')) return;
    var s = document.createElement('style');
    s.id = 'pl-cep-cue-style';
    s.textContent =
      '.pl-cep-cue{font-size:13px;line-height:1.45;color:#5b4a55;text-align:center;padding:10px 14px;font-family:var(--montserrat,inherit)}' +
      // o tema tem display próprio na barra que ignora o atributo [hidden] — força o esconder
      'progress-bar.progress-bar[hidden]{display:none!important}' +
      // esconde a régua duplicada do bundle (lógica antiga da agência) — fica só a barra bonita
      '.plenitude-free-shipping-ruler{display:none!important}';
    document.head.appendChild(s);
  }

  // ---------- init ----------
  function init() {
    injectStyle();
    hookInputs();
    applyAll();
    obs = new MutationObserver(function () { hookInputs(); scheduleApply(); });
    obs.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* pl-pix-fix v2: o bundle da agencia calcula o TOTAL pix do carrinho com 5% cravado
   (updatePixDiscount -> Math.round(s*.05)). Este override le settings.pix_discount e:
   1) NAO aplica o % de novo quando um cupom AVISTA* ja esta aplicado no carrinho —
      o cupom E o desconto a vista; antes duplicava (item -10% e total -10% de novo);
   2) NUNCA desconta o frete estimado (o cupom no checkout tambem nao desconta frete);
   3) esconde a etiqueta do cupom AVISTA* no item e a linha "Descontos" do resumo (o
      preco "no Pix/boleto" do item ja comunica o desconto; o checkout segue integro).
   Sobrevive a rebuilds do bundle (main-*.js): se os metodos sumirem, vira no-op. */
(function () {
  'use strict';
  if (!window.customElements || !customElements.whenDefined) return;

  var AVISTA = /^AVISTA/i; // familia de cupons "a vista" (AVISTA10OFF, AVISTA5OFF...)

  function money(cents) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(cents / 100);
  }
  function isAvista(code) { return AVISTA.test(String(code || '').trim()); }
  function hasAvista(cart) {
    return !!(cart && (cart.discount_codes || []).some(function (c) {
      return isAvista(c.code) && c.applicable !== false;
    }));
  }
  // soma dos descontos que NAO sao da familia AVISTA — a linha "Descontos" mostra so eles
  function nonAvistaDiscount(cart) {
    if (!cart) return 0;
    var avista = 0;
    (cart.items || []).forEach(function (it) {
      (it.line_level_discount_allocations || []).forEach(function (al) {
        var ap = al.discount_application || {};
        if (ap.type === 'discount_code' && isAvista(ap.title)) avista += Number(al.amount) || 0;
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (ap) {
      if (ap.type === 'discount_code' && isAvista(ap.title)) avista += Number(ap.total_allocated_amount) || 0;
    });
    return Math.max(0, (Number(cart.total_discount) || 0) - avista);
  }

  // etiqueta AVISTA* some na hora via CSS (:has); o JS abaixo cobre browser antigo
  (function css() {
    if (document.getElementById('pl-avista-ui-style')) return;
    var s = document.createElement('style');
    s.id = 'pl-avista-ui-style';
    s.textContent = '.cart-item__discount-tag:has([data-code^="AVISTA"]),.cart-item__discount-tag:has([data-code^="avista"]){display:none!important}';
    document.head.appendChild(s);
  })();

  customElements.whenDefined('cart-checkout').then(function () {
    var C = customElements.get('cart-checkout');
    if (!C || !C.prototype) return;

    // updateCheckoutInfo recebe o carrinho inteiro — guarda na instancia p/ o pix saber dos cupons
    if (typeof C.prototype.updateCheckoutInfo === 'function' && !C.prototype.__plAvistaWrapped) {
      C.prototype.__plAvistaWrapped = true;
      var orig = C.prototype.updateCheckoutInfo;
      C.prototype.updateCheckoutInfo = function (t) {
        this.__plCart = t || this.__plCart;
        orig.call(this, t);
        try { plAdjustRows(this); } catch (e) {}
      };
    }

    if (typeof C.prototype.updatePixDiscount === 'function') {
      C.prototype.updatePixDiscount = function (t) {
        var e = this.querySelector('.cart-checkout__pix-text');
        var i = this.querySelector('.cart-checkout__pix-value');
        if (!e || !i) return;
        var s;
        if (t !== undefined) {
          s = t;
          e.setAttribute('data-total-price', money(t));
        } else {
          s = Number(String(e.dataset.totalPrice || '').replace(/\D/g, '')) || 0;
        }
        var pct = Number(window.Shopify && Shopify.theme && Shopify.theme.settings && Shopify.theme.settings.pix_discount);
        if (!isFinite(pct) || pct <= 0 || pct >= 100) pct = 5;
        var frete = Number(this.shippingEstimateCents) || 0; // frete fica fora do desconto
        var produtos = Math.max(0, s - frete);
        if (!hasAvista(this.__plCart)) {
          produtos -= Math.round(produtos * (pct / 100)); // sem cupom: aplica a promessa a vista
        } // com cupom AVISTA*: produtos ja vieram descontados — nao aplica de novo
        i.textContent = money(produtos + frete);
      };
    }

    // preco unitario dos itens: o re-render JS do bundle deriva o pix de item.price
    // (ja descontado pelo cupom) — reescreve com base no original_price do item
    function plFixItemPrices(cart) {
      if (!hasAvista(cart)) return;
      var pct = Number(window.Shopify && Shopify.theme && Shopify.theme.settings && Shopify.theme.settings.pix_discount);
      if (!isFinite(pct) || pct <= 0 || pct >= 100) pct = 5;
      (cart.items || []).forEach(function (it) {
        var fin = Number(it.final_price) || 0;
        var orig = Number(it.original_price) || fin;
        if (!fin || fin === orig) return; // item sem desconto de linha
        document.querySelectorAll('.cart-item product-price').forEach(function (pp) {
          var shown = Number(pp.getAttribute('data-unformatted-price')) || 0;
          if (shown !== fin) return; // card montado com o preco descontado -> corrige
          var pix = Math.ceil(orig * (1 - pct / 100));
          pp.setAttribute('data-price', money(orig));
          pp.setAttribute('data-unformatted-price', String(orig));
          pp.setAttribute('data-pix-price', money(pix));
          pp.setAttribute('data-unformatted-pix-price', String(pix));
          var cur = pp.querySelector('.product-price__current');
          if (cur) {
            for (var k = 0; k < cur.childNodes.length; k++) {
              var nd = cur.childNodes[k];
              if (nd.nodeType === 3 && /\d/.test(nd.textContent)) { nd.textContent = ' ' + money(pix) + ' '; break; }
            }
          }
        });
      });
    }

    // linha "Descontos", subtotal e etiquetas — AVISTA* fica invisivel no drawer
    function plAdjustRows(el) {
      var cart = el.__plCart;
      if (!cart) return;
      var extra = nonAvistaDiscount(cart);
      var row = el.querySelector('.cart-checkout__discounts');
      var val = el.querySelector('[data-cart-value="discounts"]');
      if (row) row.hidden = extra <= 0;
      if (val) val.textContent = extra > 0 ? '-' + money(extra) : money(0);
      // com cupom a vista: subtotal mostra o preco cheio; a linha pix mostra o final
      var sub = el.querySelector('[data-cart-value="subtotal"]');
      if (sub && hasAvista(cart)) {
        var cheio = (cart.items || []).reduce(function (acc, it) { return acc + (Number(it.original_line_price) || 0); }, 0);
        if (cheio > 0) sub.textContent = money(cheio);
      }
      // fallback sem :has(): esconde a etiqueta via JS
      document.querySelectorAll('.cart-item__discount-tag [data-code]').forEach(function (b) {
        if (isAvista(b.getAttribute('data-code'))) {
          var tag = b.closest('.cart-item__discount-tag');
          if (tag) tag.style.display = 'none';
        }
      });
      try { el.updatePixDiscount((Number(cart.total_price) || 0) + (Number(el.shippingEstimateCents) || 0)); } catch (e) {}
      plFixItemPrices(cart);
      // o re-render dos itens pode rodar depois deste hook — repassa no frame seguinte
      requestAnimationFrame(function () { try { plFixItemPrices(cart); } catch (e) {} });
    }

    // estado inicial (page load): busca o carrinho 1x p/ saber se ja ha cupom aplicado
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('cart-checkout').forEach(function (el) {
        el.__plCart = cart;
        try { plAdjustRows(el); } catch (e) {}
      });
    }).catch(function () {
      document.querySelectorAll('cart-checkout').forEach(function (el) {
        try { el.updatePixDiscount(); } catch (err) {}
      });
    });
  }).catch(function () {});
})();

/* pl-pix-cards: cards de beneficio (metaobject) com "N% OFF ... Pix" seguem a config
   settings.pix_discount — se o time mudar o % e esquecer o card, o front corrige. */
(function () {
  function sync() {
    var v = Number(window.Shopify && Shopify.theme && Shopify.theme.settings && Shopify.theme.settings.pix_discount);
    if (!isFinite(v) || v <= 0 || v >= 100) return;
    var label = String(v).replace('.', ',') + '% OFF';
    document.querySelectorAll('p.text-block').forEach(function (p) {
      if (!/pix/i.test(p.textContent || '')) return;
      p.querySelectorAll('strong, b').forEach(function (s) {
        var t = (s.textContent || '').trim();
        if (/^\d+(?:[.,]\d+)?%\s*OFF$/.test(t) && t !== label) s.textContent = label;
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync);
  else sync();
})();
